<template>
  <el-row class="mb-3" v-if="amReady">
    <div class="m-0 p-0 mb-4" v-if="formHeader">
      <h6>{{ this.getFormTitle }}</h6>
    </div>
    <div class="mb-2" v-else></div>

    <el-col :class="$langConfig.cssClass" :span="(!editMode)? 6 : 6">
      <dg-text-field
          :control="control"
          :field_span="22"
            :label_span="22"
          :translateLabel="false"
          field_mark="required"
          label="CC"
          name="cc"
          placeholder="122"
          rules="required"></dg-text-field>
    </el-col>

    <el-col :class="$langConfig.cssClass" :span="(!editMode)? 6 : 6">
      <dg-select-field
          :control="control"
          :field_span="22"
            :label_span="22"
          :options="destinationsDropDownList"
          :translateLabel="false"
          :translateLabels="false"
          field_mark="required"
          htmlautocomplete="new-password"
          label="Destination"
          labelProperty="label"
          placeholder="Canada / ATI"
          name="destination_id"
          rules="required"
          valueProperty="value"
      ></dg-select-field>
    </el-col>
    <el-col :class="$langConfig.cssClass" :span="(!editMode)? 6 : 6">
      <dg-text-field
          :control="control"
          :field_span="22"
            :label_span="22"
          :translateLabel="false"
          label="MCC"
          name="mcc"
          placeholder="122"></dg-text-field>
    </el-col>
    <el-col :class="$langConfig.cssClass" :span="(!editMode)? 6 : 6">
      <dg-text-field
          :control="control"
          :field_span="22"
            :label_span="22"
          :translateLabel="false"
          label="MNC"
          name="mnc"
          placeholder="122"></dg-text-field>
    </el-col>


    <el-col :span="24" class="mt-2 border-top">
      <el-col :class="$langConfig.cssClass" :span="12" class="mt-4">
        <dg-label-field class="error-field-validate-message" label="fields_do_not_match_the_required_criteria"
                        v-show="!this.validData"></dg-label-field>
      </el-col>
      <el-col :span="12" class="pt-3 text-right">
        <dg-confirm-button
            :loading="requestOn"
            :onConfirm="removeAction"
            :translate="false"
            class="mr-2"
            confirmButtonType="danger"
            fieldSize="mini"
            icon="el-icon-delete"
            popIcon="el-icon-delete"
            text="remove"
            title="sure to removing this record ?"
            type="danger"
            v-if="editMode"></dg-confirm-button>

        <dg-button :click="cancelEditable" class="mr-2" fieldSize="mini" icon="el-icon-close" text="cancel"
                   type="warning" v-if="editable && editMode"></dg-button>
        <dg-button :click="changeEditable" fieldSize="mini" icon="el-icon-edit" text="edit" type="success"
                   v-if="!editable && editMode"></dg-button>
        <dg-confirm-button
            :icon="actionButtonIcon"
            :loading="requestOn"
            :onConfirm="createModule"
            :text="actionButtonLabel"
            :translate="false"
            :type="actionButtonType"
            fieldSize="mini"
            v-if="editable"></dg-confirm-button>
      </el-col>
    </el-col>
  </el-row>
</template>

<script>


import fieldController from 'devegram-vue-data-collecter-eui/src/mixins/fieldController';
import module from './../index.js'
import {notify} from '@/system-services/notify.js'

export default {
  mixins: [fieldController],
  props: {
    formHeader: {
      required: false,
      default: false
    },
    formTitle: {
      required: false
    },
    editMode: {
      required: true,
      type: Boolean
    },
    onEditCallback: {
      required: false
    },
    onCreateCallback: {
      required: false
    },
  },
  data() {
    return {
      control: this,
      amReady: true,
      requestOn: false,
      editable: !this.editMode,
      destinationsDropDownList: [],
      module: {
        ...module
      },
    }
  },
  computed: {
    ...$mapState('voip-dialplan-sms-state', ['openedEntity']),
    ...$mapState('ajaxManager', ['loadingRequests']),
    getFormTitle: function () {
      if (this.formTitle) {
        return this.formTitle
      } else {
        return ((!this.editMode) ? this.$ml.get('create') : this.$ml.get('edit')) + ' ' + this.module.info.caption
      }
    },
    actionButtonLabel: function () {
      if (!this.editMode) {
        return 'create';
      } else {
        return 'save'
      }
    },
    actionButtonIcon: function () {
      if (!this.editMode) {
        return 'el-icon-plus';
      } else {
        return 'el-icon-check'
      }
    },
    actionButtonType: function () {
      if (!this.validData) {
        return 'danger btn-small';
      } else {
        if (!this.editMode) {
          return 'primary app-bg-primary';
        } else {
          return 'primary'
        }
      }
    }
  },
  beforeMount() {
    this.getDestinationsDropdownlist().then(r => {
      this.destinationsDropDownList = r
    })
  },
  methods: {
    ...$mapActions('voip-dialplan-sms-state', ['addEntity']),
    ...$mapActions('voip-destination-sms-api', {getDestinationsDropdownlist: 'getDropDownList'}),
    cancelEditable() {
      let context = this
      this.amReady = false
      this.editable = false
      $vue.nextTick(() => {
        context.amReady = true
      })
    },
    changeEditable() {
      this.editable = !this.editable
    },
    getEntityField() {
      return JSON.parse(this.openedEntity.fields);
    },
    removeAction(params) {
      let cxt = this
      this.requestOn = true
      this.$store.dispatch(this.module.info.name + '-api/remove', {id: this.recordId}).then(response => {
        notify({
          type: 'success',
          title: this.$ml.get('deleted'),
          message: '',
          position: 'topRight',
          close: false,
          timeout: 1900,
          animateInside: true,
        });
        cxt.amReady = false
      })
    },
    createModule() {
      this.validateFields().then(result => {
        if (!result) return

        this.requestOn = true
        let context = this;
        let data = {data: this.dataModel};
        if (this.editMode) {
          data.id = this.dataToBind.id;
        }

        let api = (this.editMode) ? 'update' : 'create';
        
        this.$store.dispatch(this.module.info.name + '-api/' + api, data).then(response => {
        if(response?.data.status == false){
            notify({
            type: 'warning',
            title: response?.data?.message,
            message: '',
            position: 'topRight',
            close: false,
            timeout: 1900,
            animateInside: true,
          });
          $vue.nextTick(() => {
            context.amReady = true
            context.requestOn = false
         
          })
        }
        else if(response?.data.status == 'failed'){
            notify({
            type: 'failed',
            title: 'Failed',
            message: '',
            position: 'topRight',
            close: false,
            timeout: 1900,
            animateInside: true,
          });
          $vue.nextTick(() => {
            context.amReady = true
            context.requestOn = false
         
          })
          }else{
            notify({
            type: 'success',
            title: this.$ml.get('successfully'),
            message: '',
            position: 'topRight',
            close: false,
            timeout: 1900,
            animateInside: true,
          });

          $vue.nextTick(() => {
            context.amReady = true
            context.requestOn = false
            if (context.editMode) {
              if (context.onEditCallback) {
                context.onEditCallback(response.data)
              }
            } else {
              if (context.onCreateCallback) {
                context.onCreateCallback(response.data)
              }
            }
          })
          }
          this.amReady = false
        
          // this.$router.push({ name: this.module.stateName + '-module-list', params: {}}).then( response => {})
        }).catch(error => {
          console.log('catch error', error)
          this.setfieldsErrorMessage({
            fieldsErrors: error.response.data
          });
        }).finally(() => {
          this.requestOn = false
        })

      })
    }
  }
}
</script>
